export default __webpack_public_path__ + "static/media/firestorm.ec4b2393.png";